// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1FsUk","amount":"Amount_amount__2fHYl","tip":"Amount_tip__2EpFW","tipHeader":"Amount_tipHeader__kyGRP","tipsWrap":"Amount_tipsWrap__ogYf3"};